import { Navigate } from "react-router-dom";

export interface IProtectedComponentProps {
  isAuth: boolean;
  children: JSX.Element;
}

export function ProtectedRoute(props: IProtectedComponentProps) {
  const { isAuth, children } = props;

  if (!isAuth) {
    return <Navigate to="/login" />;
  }
  return children;
}

export default ProtectedRoute;
